<p style="text-align: {data.align || ''}">
  <slot></slot>
</p>

<style>
  p {
    line-height: 1.75;
    color: #424448;
    margin-bottom: 1.5rem;
    @media(min-width: 992px) {
      font-size: 1.125rem;
    }
  }
</style>
